import { lazy } from "react"
import {
  EDIT_PARCEL_VIEW,
  NEW_PARCEL_EVENT_VIEW,
  NEW_PARCEL_VIEW,
  PARCEL_EVENT_VIEW,
  PARCEL_EVENTS_VIEW,
  PARCEL_VIEW,
  PARCELS_LIST_VIEW,
} from "./route-list"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

const AllParcelEventsView = lazy(
  () =>
    import(
      "@/features/events/parcel-events/views/all-parcel-events-view/all-parcel-events-view"
    ),
)
const NewParcelEventView = lazy(
  () =>
    import(
      "@/features/events/parcel-events/views/new-parcel-event-view/new-parcel-event-view"
    ),
)
const ParcelEventView = lazy(
  () =>
    import(
      "@/features/events/parcel-events/views/parcel-event-view/parcel-event-view"
    ),
)
const MyParcelsView = lazy(
  () => import("@/features/parcels/views/my-parcels-view/my-parcels-view"),
)
const NewParcelView = lazy(
  () => import("@/features/parcels/views/new-parcel-view/new-parcel-view"),
)
const ParcelEditView = lazy(
  () => import("@/features/parcels/views/parcel-edit-view/parcel-edit-view"),
)
const ParcelView = lazy(
  () => import("@/features/parcels/views/parcel-view/parcel-view"),
)
export const parcelRoutes = [
  {
    path: PARCELS_LIST_VIEW,
    element: <MyParcelsView />,
  },
  {
    path: NEW_PARCEL_VIEW,
    element: <NewParcelView />,
  },
  {
    path: PARCEL_VIEW,
    element: <ParcelView />,
  },
  {
    path: EDIT_PARCEL_VIEW,
    element: <ParcelEditView />,
  },
  {
    path: PARCEL_EVENTS_VIEW,
    element: <AllParcelEventsView />,
  },
  {
    path: NEW_PARCEL_EVENT_VIEW,
    element: <NewParcelEventView />,
  },
  {
    path: PARCEL_EVENT_VIEW,
    element: <ParcelEventView />,
  },
]

const MOBILE_PARCELS_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: parcelRoutes,
  },
]

const DESKTOP_PARCELS_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: parcelRoutes,
  },
]

export const getParcelRoutes = (isDesktop: boolean) => {
  return isDesktop ? DESKTOP_PARCELS_ROUTES : MOBILE_PARCELS_ROUTES
}
